/**
 * Color Families Slider Enhancement
 * Scrolls by a full page (3 items) instead of one at a time
 * Adds smoother scroll behavior
 */
(function() {
  'use strict';

  function initColorFamiliesSlider() {
    const colorFamiliesSection = document.querySelector('#SectionColumns--color-families');
    if (!colorFamiliesSection) return;

    const gridSlider = colorFamiliesSection.querySelector('grid-slider');
    if (!gridSlider) return;

    const slider = gridSlider.querySelector('[data-grid-slider]');
    const slides = gridSlider.querySelectorAll('[data-grid-item]');
    if (!slider || slides.length === 0) return;

    // Get visible items count (defaults to 3 for desktop)
    function getVisibleCount() {
      const sliderWidth = slider.clientWidth;
      const slideWidth = slides[0].clientWidth;
      return Math.floor(sliderWidth / slideWidth) || 3;
    }

    // Override arrow click behavior
    const buttons = gridSlider.querySelectorAll('[data-button-arrow]');

    buttons.forEach((button) => {
      // Remove existing listeners by cloning
      const newButton = button.cloneNode(true);
      button.parentNode.replaceChild(newButton, button);

      newButton.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();

        const visibleCount = getVisibleCount();
        const slideWidth = slides[0].clientWidth;
        const gap = parseInt(getComputedStyle(slider).gap) || 20;
        const scrollAmount = (slideWidth + gap) * visibleCount;

        const currentScroll = slider.scrollLeft;
        let newScroll;

        if (newButton.hasAttribute('data-button-prev')) {
          newScroll = currentScroll - scrollAmount;
        } else if (newButton.hasAttribute('data-button-next')) {
          newScroll = currentScroll + scrollAmount;
        }

        slider.scrollTo({
          top: 0,
          left: newScroll,
          behavior: 'smooth'
        });
      });
    });

    // Add smooth scroll CSS
    slider.style.scrollBehavior = 'smooth';
    slider.style.scrollSnapType = 'x mandatory';

    // Add snap alignment to slides
    slides.forEach((slide) => {
      slide.style.scrollSnapAlign = 'start';
    });
  }

  // Make card images clickable — navigate to the button URL
  function initClickableImages() {
    document.querySelectorAll('.section-columns .grid-item').forEach(function(card) {
      var link = card.querySelector('.column__btn a');
      var image = card.querySelector('.column__image');
      if (link && image) {
        image.addEventListener('click', function() {
          window.location.href = link.href;
        });
      }
    });
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initColorFamiliesSlider();
      initClickableImages();
    });
  } else {
    // DOM already loaded, wait a bit for Shopify components to initialize
    setTimeout(function() {
      initColorFamiliesSlider();
      initClickableImages();
    }, 500);
  }

  // Re-initialize on Shopify section load (for theme editor)
  document.addEventListener('shopify:section:load', (e) => {
    if (e.detail.sectionId === 'color-families') {
      setTimeout(initColorFamiliesSlider, 100);
    }
  });
})();
